import React from "react";
import styled, { css } from "styled-components";
import { Flex, Box } from "rebass";
import { ULink } from "../components/ULink";
import Eye from "../icons/Eye";
import useIsScrolled from "../hooks/useIsScrolled";
import ThemeSwitch from "../components/ThemeSwitch";
import ProjectsListing from "../components/ProjectsListing";
import useMediaQuery from "../hooks/useMediaQuery";

const Header = () => {
  const isScrolled = useIsScrolled(100);
  const isDesktop = useMediaQuery("(min-width: 1920px)");
  return (
    <>
      <SyledHeader isScrolled={isScrolled}>
        <Flex
          flexWrap="wrap"
          alignItems="center"
          variant="containerHeader"
          color="heading"
          justifyContent="space-between"
          py={[3,4]}
        >
          <Box
            order={[1, 1, 1, 1, 1]}
            width={[1 / 1, "auto", "auto", "auto", 1 / 3]}
          >
            <NavLeft>
              <ULink
                to="/work"
                activeClassName="active"
                sx={{
                  variant: "links.nav",
                  mr: [1, 2, 2],
                }}
              >
                Work
              </ULink>
              <ULink
                to="/process"
                activeClassName="active"
                sx={{
                  variant: "links.nav",
                  mr: [1, 2, 2],
                }}
              >
                Process
              </ULink>
              <ULink
                to="/expertise"
                activeClassName="active"
                sx={{
                  variant: "links.nav",
                  mr: [0, 0, 0, 0],
                }}
              >
                Expertise
              </ULink>
            </NavLeft>
          </Box>
          <Box
            order={[0, 0, 0, 0, 1]}
            width={[1 / 1, 1 / 1, 1 / 1, 1 / 1, 1 / 3]}
            pb={[3, 3, 3, 0]}
          >
            <Logo>
              <ULink to="/" activeClassName="active">
                <Eye />
              </ULink>
            </Logo>
          </Box>
          <Box
            order={[1, 1, 1, 1, 1]}
            width={[1 / 1, "auto", "auto", "auto", 1 / 3]}
          >
            <NavRight>
              <ThemeSwitch />
            </NavRight>
          </Box>
        </Flex>
      </SyledHeader>
      <StyledDiv isDesktop={isDesktop}>
        <ProjectsListing />
      </StyledDiv>
    </>
  );
};

const SyledHeader = styled.header<{ isScrolled: boolean }>`
  color: inherit;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 9999;
  transition: background-color 0.3s ease-in-out;
  ${({ isScrolled }) =>
    isScrolled &&
    css`
      background: transparent;
      -webkit-backdrop-filter: blur(72px);
      backdrop-filter: blur(72px);
    `};
  @media only screen and (min-width: 64em) {
    position: fixed;
  }
`;
const NavLeft = styled.div`
  text-align: left;
  overflow-x: auto;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  & ::-webkit-scrollbar {
    display: none;
  }
`;
const Logo = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const NavRight = styled.div`
  display: none;
  @media only screen and (min-width: 52em) {
    text-align: right;
    display: block;
  }
`;

const StyledDiv = styled.div<{ isDesktop: boolean }>`
  display: none;
  ${({ isDesktop }) =>
    isDesktop &&
    css`
      display: block;
    `};
`;

export default Header;
